<template>
    <div>

     <v-container>
     		<!-- Form -->
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-form v-model="valid" ref="form" lazy-validation>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>							 
							<v-flex xs12 sm4 md6>
								 <v-text-field label="Type Name" v-model="formSchema.name" :rules="[v => !!v || 'Field is required']" required></v-text-field>
							</v-flex>
                <v-flex xs12 sm6 md4>	
								     <v-checkbox v-model="formSchema.active" label="Active" :value="isActiveVal"></v-checkbox>
									</v-flex>
						</v-layout>
					</v-container>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="success" @click.native="validateBeforeSubmit">{{btnTitle}}</v-btn>
					<v-btn color="error"  @click.native="reset">Reset</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
		<!-- /Form -->  
     </v-container>
      
    </div>
</template>

<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import Axios from 'axios'
export default {
    props:['formSchema'],
    data: () => ({
      valid: true,     
      isActiveVal: 0
    }),

    computed: {
      formTitle () {
        return this.formSchema.id > 0 ? 'Update Procurement Type' : 'New Procurement Type'
      },
      btnTitle () {
        return this.formSchema.id > 0 ? 'Update' : 'Save'
      },
    },

    created () { },
   
    methods: {

      validateBeforeSubmit(e) {
        var formSchema = this.formSchema
        var root = this

        if (this.$refs.form.validate()) {
          if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(this.formSchema, 'proc_types').then(res => {
                let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status
              };
              this.close(actionData);
            });
          }
          else
          {            
            commonService.insertFormData(this.formSchema, 'proc_types').then(res => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status
              };
              this.close(actionData);
            });
          }
        }  
      },

      close(data){
        if(data.status == 1)
      		{
				 this.$refs.form.reset();
				 }				
				this.$emit('emitCloseModal', data)
      },

      reset() {
      if (this.formSchema.id > 0) {
        // close(0);
         let actionData = {
                message: "Form Reset",
                data: this.formSchema,
                action: "edit",
                status: 1,
          };
        this.$emit("emitCloseModal", actionData);
        this.$refs.form.reset();
      } else {
        this.$refs.form.reset();
      }
    },

    },
}
</script>



// WEBPACK FOOTER //
// src/components/procurement/type/typeForm.vue